/* Articles AI — dynamic product cards inside blog articles.
 *
 * Any in-article link to /products/<handle> gets a product card appended
 * after its paragraph, hydrated at page-view time from the public
 * /products/<handle>.js endpoint: title, vendor, CURRENT featured image and
 * CURRENT price. Change the product photo tomorrow and every article follows.
 *
 * Progressive enhancement: if fetch fails (or the product is gone or out of
 * stock) the plain inline link keeps working and no card appears.
 */
(function () {
  var content = document.querySelector('.article-template__content');
  if (!content) return;

  // EVERY in-article link opens in a new tab — internal products included:
  // the reader must never lose the article (a Vogue source link would
  // otherwise navigate them away from the shop entirely).
  content.querySelectorAll('a[href]').forEach(function (a) {
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) === '#') return; // in-page anchors stay in-page
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener');
  });

  var seen = {};
  content.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
    var m = (a.getAttribute('href') || '').match(/\/products\/([a-z0-9-]+)/);
    if (!m || seen[m[1]]) return;
    seen[m[1]] = true;
    var handle = m[1];

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.available) return; // never promote an out-of-stock product
        var img = p.featured_image || (p.images && p.images[0]);
        var price = (p.price / 100).toFixed(2).replace('.', ',') + ' €';

        var card = document.createElement('aside');
        card.className = 'bof-product-card';
        var A = '<a target="_blank" rel="noopener" href="/products/' + handle + '"';
        card.innerHTML =
          (img
            ? A + ' tabindex="-1"><img class="bof-product-card__img" loading="lazy" src="' + resize(img, 360) + '" alt="' + esc(p.title) + '"></a>'
            : '') +
          '<div class="bof-product-card__info">' +
            '<p class="bof-product-card__vendor">' + esc(p.vendor) + '</p>' +
            '<p class="bof-product-card__title">' + A + '>' + esc(p.title) + '</a></p>' +
            '<p class="bof-product-card__price">' + price + '</p>' +
          '</div>' +
          A + ' class="button button--secondary bof-product-card__cta">Scopri</a>';

        // After the block containing the link; if the link sits in a list,
        // after the whole list (an <aside> inside a <ul> is invalid).
        var host = a.closest('p, h2, h3') || a;
        var list = a.closest('ul, ol');
        if (list) host = list;
        host.parentNode.insertBefore(card, host.nextSibling);
      })
      .catch(function () {});
  });

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML.replace(/"/g, '&quot;');
  }

  function resize(url, size) {
    return url.indexOf('/cdn/') !== -1 || url.indexOf('cdn.shopify.com') !== -1
      ? url.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_' + size + 'x' + size + '$1$2')
      : url;
  }
})();
